import AMApp from '../../global/app';
import Handlebars from 'handlebars';

export const HeaderSearch = () => {
  const amApp = new AMApp();

  const routeSearch = AMApp.langGetParam + 'eID=fonds&function=searchHeader&search=';

  const SEARCH_ACTIVE = 'search__active';
  const SEARCH_RESULT_ACTIVE = 'search-result__active';
  const HEADER_SEARCH_INPUT = '#header_search_input';
  const HEADER_SEARCH_RESULT_TEMPLATE = '#header_search_result_template';
  const HEADER_SEARCH_RESULT_TARGET = '#header_search_result_target';

  const headerSearch = document.querySelector('#header_search');
  const headerSearchToggle = document.querySelector('#header_search_toggle');
  const mainMenu = document.querySelector('#mainmenu');
  const headerSearchForm = document.querySelector('#header_search_form');
  const headerSearchInput = document.querySelector(HEADER_SEARCH_INPUT);
  const headerSearchResult = document.querySelector('#header_search_result');
  const headerSearchButton = document.querySelector('#header_search_button');
  const headerSearchResultTemplateSel = document.querySelector(HEADER_SEARCH_RESULT_TEMPLATE);
  const mainMenuItem = document.querySelectorAll('.mainmenu-list-item__lv1');
  const body = document.querySelector('body');

  const headerSearchResultTemplateRaw = headerSearchResultTemplateSel.innerHTML;
  const headerSearchResultTemplate = Handlebars.compile(amApp.toHandlebarsDelimiters(headerSearchResultTemplateRaw));
  const headerSearchResultTarget = document.querySelector(HEADER_SEARCH_RESULT_TARGET);

  const show = el => el && el.style.removeProperty('display'); // nutzt evtl. vorhandenes CSS
  const hide = el => el && (el.style.display = 'none');


  let timeoutId = null;
  let hasResult = null;

  headerSearchToggle.addEventListener('click', (e) => {
    handleSearchToggle(e.target);
  });

  headerSearchInput.addEventListener('keyup', (e) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      getSearchResult(e.target.value);
    }, 500);
  });

  headerSearchInput.addEventListener('click focus', (e) => {
    if (hasResult) {
      headerSearchResult.classList.toggle(SEARCH_RESULT_ACTIVE, true);
    }
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest(HEADER_SEARCH_INPUT)) {
      headerSearchResult.classList.toggle(SEARCH_RESULT_ACTIVE, false);
    }
  });

  Handlebars.registerHelper("cleanString", function(str) {
    str = Handlebars.escapeExpression(str);
    return new Handlebars.SafeString(str);
  });

  /**
   * Toggles the visibility and state of the search functionality in the header menu.
   *
   * @param {HTMLElement} elem - The element that was clicked to toggle the search state.
   * @return {void} This function does not return a value.
   */
  function handleSearchToggle(elem) {
    const mainMenuWidth = mainMenu.offsetWidth;
    const isActive = headerSearch.classList.contains(SEARCH_ACTIVE);

    if (isActive) {
      elem.classList.add('lbbw-icf--lupe');
      elem.classList.remove('lbbw-icf--close');

      headerSearch.classList.remove(SEARCH_ACTIVE);
      headerSearch.closest('.header-main')
        .classList
        .remove('header-search__active');
      headerSearchForm.removeAttribute('style');
      headerSearchInput.setAttribute('tabindex', '-1');
    } else {
      headerSearch.classList.add(SEARCH_ACTIVE);

      if (window.innerWidth >= AMApp.CONSTANTS.BREAKPOINT.LG) {
        headerSearchForm.style.width = `${mainMenuWidth + 100}px`;
      } else {
        headerSearch.closest('.header-main')
          .classList
          .add('header-search__active');
      }

      mainMenuItem.forEach(item => {
        item.classList.remove('mainmenu-list-item__lv1--active');
      });
      headerSearchInput.setAttribute('tabindex', '0');

      if (headerSearchInput) {
        headerSearchInput.setAttribute('tabindex', '0');
        headerSearchInput.focus();
        headerSearchInput.value = '';
      }

      // close other flyout (nach 600ms)
      setTimeout(() => {
        body.classList.remove('openflyout');
      }, 600);

      // remove lupe and show close icon (nach 300ms)
      setTimeout(() => {
        elem.classList.remove('lbbw-icf--lupe');
        elem.classList.add('lbbw-icf--close');
      }, 300);
    }
  }

  /**
   *
   * @param searchInput
   */
  function getSearchResult(searchInput) {
    searchInput = searchInput.replace(/\s/i, '%20')
      .toLowerCase();

    headerSearchButton.style.display = 'none';

    const next = headerSearchInput.nextElementSibling;
    const hasLoadingNext = next && next.matches('.loading');

    if (!hasLoadingNext) {
      headerSearchInput.insertAdjacentHTML('afterend', AMApp.LOADING_ANIMATION);
    }

    let parameter = '&target=R';
    amApp.isInstitutionell() ? parameter += '&target=I' : parameter += '&target=R';

    const request = AMApp.basePath + routeSearch + searchInput + parameter;
    const url = encodeURI(request);

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then(result => {
        setTimeout(() => {
          renderSearchResult(result);
        }, 250);
      })
      .catch(() => {
        setStatusError();
      });
  }

  /**
   *
   * @param result
   */
  function renderSearchResult(result) {
    result.allResults = result.fondsResults + result.contentResults + result.downloadsResults;

    const getText = (html) => {
      const div = document.createElement('div');
      div.innerHTML = html;
      return (div.textContent || '').trim();
    };

    result.fondsDocs.forEach(fonds => {
      fonds.ISIN = getText(fonds.INSD_ISIN);
    });

    headerSearchResultTarget.innerHTML = headerSearchResultTemplate(result);

    const fondsResult = document.getElementById('fonds_result');
    const fondsNoResult = document.getElementById('fonds_no_result');
    const contentResult = document.getElementById('content_result');
    const contentNoResult = document.getElementById('content_no_result');
    const allResult = document.getElementById('all_result');
    const allNoResult = document.getElementById('all_no_result');

    setStatusResult();

    if (result.fondsDocs.length > 0) {
      show(fondsResult);
      hide(fondsNoResult);
      fondsNoResult.setAttribute('aria-hidden', 'true');
    } else {
      hide(fondsResult);
      show(fondsNoResult);
      fondsNoResult.removeAttribute('aria-hidden');
    }

    if (result.contentDocs.length > 0) {
      show(contentResult);
      hide(contentNoResult);
      contentNoResult.setAttribute('aria-hidden', 'true');
    } else {
      hide(contentResult);
      show(contentNoResult);
      contentNoResult.removeAttribute('aria-hidden');
    }

    if (
      (result.fondsDocs.length > 0) ||
      (result.contentDocs.length > 0) ||
      (result.downloads.length > 0)
    ) {
      show(allResult);
      hide(allNoResult);
      allNoResult.setAttribute('aria-hidden', 'true');
    } else {
      hide(allResult);
      show(allNoResult);
      allNoResult.removeAttribute('aria-hidden');
    }
    
    // Screenreader über Aktualisierung informieren
    announceSearchResults(result);
  }

  /**
   * Announce search results or no-results to screen readers via a live region
   * @param {object} result
   */
  function announceSearchResults(result) {
    let message;
    // result.allResults wird am Anfang von renderSearchResult berechnet
    if (result.allResults === 0) {
      message = 'Keine Treffer gefunden.';
    } else {
      message = result.allResults + ' Treffer gefunden.';
    }

    let liveRegion = document.getElementById('header_search_live_region');
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.setAttribute('id', 'header_search_live_region');
      liveRegion.setAttribute('class', 'sr-only');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      document.body.appendChild(liveRegion);
    }

    // Inhalt kurz leeren, damit auch gleiche Nachrichten erneut vorgelesen werden
    liveRegion.textContent = '';
    setTimeout(() => {
      liveRegion.textContent = message;
    }, 100);
  }

  function removeLoader() {
    const loader = document.querySelector('#header_search .loader');
    if (loader) loader.remove();
  }

  function setStatusResult() {
    show(headerSearchButton);
    headerSearchResult.classList.toggle(SEARCH_RESULT_ACTIVE, true);
    hasResult = true;
    removeLoader();
  }

  function setStatusError() {
    show(headerSearchButton);
    headerSearchResult.classList.toggle(SEARCH_RESULT_ACTIVE, true);
    hide(headerSearchResultTemplateSel);
    hasResult = false;
    removeLoader();
  }
};